
export type Scope = 'all' | 'commands' | 'tickets' | 'tasks' | 'wiki' | 'people';

export interface ScopeDef {
  scope: Scope;
  label: string;
  prefix?: string;
}

export const SCOPES: readonly ScopeDef[] = [
  { scope: 'all', label: 'Всё' },
  { scope: 'commands', label: 'Команды', prefix: '>' },
  { scope: 'tickets', label: 'Заявки', prefix: '#' },
  { scope: 'tasks', label: 'Задачи', prefix: '!' },
  { scope: 'wiki', label: 'Инструкции', prefix: '?' },
  { scope: 'people', label: 'Люди', prefix: '@' },
];

export function takePrefix(
  input: string,
  current: Scope,
  available: readonly Scope[],
): { scope: Scope; text: string } {
  if (current !== 'all' || input.length === 0) return { scope: current, text: input };
  const def = SCOPES.find((s) => s.prefix === input[0] && available.includes(s.scope));
  if (!def) return { scope: current, text: input };
  return { scope: def.scope, text: input.slice(1).trimStart() };
}

export function cycleScope(current: Scope, available: readonly Scope[], step: 1 | -1): Scope {
  const i = available.indexOf(current);
  const next = (i + step + available.length) % available.length;
  return available[next] ?? 'all';
}

export const looksLikeTicketNumber = (q: string) => /^[#№]?\s*\d{1,12}$/.test(q.trim());

export const looksLikeTaskKey = (q: string) => /^[a-z][a-z0-9]{0,9}-\d{1,9}$/i.test(q.trim());
